var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-col',[_c('div',{staticClass:"tips-text flex-column f-center"},[_c('span',[_vm._v("No matter when you start, it is important not to stop after the start.")]),_c('span',[_vm._v("Copyright @ 2024 湖南简易读科技有限公司")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }